// extracted by mini-css-extract-plugin
export var collapsedSummary = "_m2-0";